(function() {
    const box = document.getElementById('main-content');
    let isMobile = /android|iphone|ipad|ipod|micromessenger/gi.test(navigator.userAgent.toLocaleLowerCase()) || window.innerWidth <= 1000;

    function getNodeList(node) {

        var list = Array.prototype.slice.call(node.querySelectorAll('[node-name]'), 0);
        var nodeList = {};

        list.forEach(function(el) {
            var name = el.getAttribute('node-name');

            if (name in nodeList) {
                nodeList[name] = [].concat(nodeList[name], el);
            } else {
                nodeList[name] = el;
            }
        });

        return nodeList;
    }

    function getOffset(el) {
        let box = el.getBoundingClientRect();
        let body = document.body;
        let clientTop = el.clientTop || body.clientTop || 0;
        let clientLeft = el.clientLeft || body.clientLeft || 0;
        let scrollTop = window.scrollY || el.scrollTop;
        let scrollLeft = window.scrollX || el.scrollLeft;
        return {
            top: box.top + scrollTop - clientTop,
            left: box.left + scrollLeft - clientLeft,
            scrollTop,
            scrollLeft
        };
    }

    let screenHeight = window.innerHeight;
    let screenWidth = window.innerWidth;

    let nodeList = getNodeList(box);
    console.log(nodeList);

    let offsetMap = {};

    document.addEventListener('scroll', function() {
        const scrollTop = window.scrollY || document.documentElement.scrollTop;
        playVideo(scrollTop);

        if (nodeList.scrollTop) {
            if (scrollTop > 100) {
                nodeList.scrollTop.style.display = 'flex';
            } else {
                nodeList.scrollTop.style.display = 'none';
            }
        }

    }, { passive: true });

    let _timer = null;
    window.addEventListener('resize', function() {
        clearTimeout(_timer);
        _timer = setTimeout(() => {
            isMobile = /android|iphone|ipad|ipod|micromessenger/gi.test(navigator.userAgent.toLocaleLowerCase()) || screenWidth <= 1000;
            initOffset();
            loadSeventh();
            loadEighth();
        }, 100);
    });

    // 初始化偏移量
    function initOffset() {
        if (nodeList.fifthBox) {
            offsetMap.fifth = {
                top: getOffset(nodeList.fifthBox).top,
                height: nodeList.fifthBox.offsetHeight,
                video: isMobile ? nodeList.mobileFiveVideo : nodeList.pcFiveVideo
            };
        }

        if (nodeList.seventhItems && nodeList.seventhCard instanceof Array) {
            offsetMap.seventh = {
                width: nodeList.seventhItems.scrollWidth,
                realWidth: nodeList.seventhItems.offsetWidth,
                box: nodeList.seventhItems,
                card: nodeList.seventhCard,
                slide: nodeList.seventhSlide,
                prev: nodeList.seventhPrev,
                next: nodeList.seventhNext,
                cardWidth: nodeList.seventhCard[0].offsetWidth + 20,
                cardLeft: isMobile ? nodeList.seventhCard.map(node => getOffset(node).left) : []
            };
        }

        if (nodeList.eighthItems && nodeList.eighthCard instanceof Array) {
            offsetMap.eighth = {
                width: nodeList.eighthItems.scrollWidth,
                realWidth: nodeList.eighthItems.offsetWidth,
                box: nodeList.eighthItems,
                card: nodeList.eighthCard,
                slide: nodeList.eighthSlide,
                prev: nodeList.eighthPrev,
                next: nodeList.eighthNext,
                cardWidth: nodeList.eighthCard[0].offsetWidth + 20,
                cardLeft: isMobile ? nodeList.eighthCard.map(node => getOffset(node).left) : []
            };
        }

        screenHeight = window.innerHeight;
        screenWidth = window.innerWidth;
    }

    initOffset();

    // 播放视频
    let videoPlay = false;

    function playVideo(scrollTop) {
        if (offsetMap.fifth) {
            const obj = offsetMap.fifth;
            if (!videoPlay && scrollTop + screenHeight > obj.top) {
                videoPlay = true;
                obj.video.play();
                nodeList.fifthPoster.classList.remove('show');
            }
        }
    }

    if (offsetMap.fifth) {
        nodeList.pcFiveVideo.addEventListener('ended', function() {
            nodeList.videoReplay.classList.add('show');
            nodeList.fifthPoster.classList.add('show');
        });
        nodeList.mobileFiveVideo.addEventListener('ended', function() {
            nodeList.videoReplay.classList.add('show');
            nodeList.fifthPoster.classList.add('show');
        });
        nodeList.videoReplay.addEventListener('click', function() {
            offsetMap.fifth.video.play();
            nodeList.videoReplay.classList.remove('show');
            nodeList.fifthPoster.classList.remove('show');
        });
    }

    // 第六屏动画
    nodeList.sixthCard && nodeList.sixthCard.forEach((node, i) => {
        node.addEventListener('mouseenter', function() {
            if (!isMobile) {
                nodeList.sixthCard.forEach(n => {
                    n.classList.remove('hover');
                });
                node.classList.add('hover');
                nodeList.hoverTips.innerHTML = nodeList.sixthCardText[i].innerHTML;
            }
        });

        node.addEventListener('click', function() {
            if (isMobile) {
                nodeList.sixthCard.forEach(n => {
                    n.classList.remove('hover');
                });
                node.classList.add('hover');
                nodeList.hoverTips.innerHTML = nodeList.sixthCardText[i].innerHTML;
            }
        });
        nodeList.hoverTips.innerHTML = nodeList.sixthCardText[0].innerHTML;
    });

    // 第七屏处理
    let sevenObj = {
        prev: false,
        next: true
    };

    function loadSeventh() {
        const obj = offsetMap.seventh;
        if (obj) {
            // 显示前后按钮
            nodeList.seventhSlide.style.display = 'none';
            if (!isMobile && obj.width > obj.realWidth + 20) {
                nodeList.seventhSlide.style.display = 'flex';
            }
        }
    }

    loadSeventh();

    if (offsetMap.seventh) {
        nodeList.seventhSlide.addEventListener('click', function(ev) {
            const node = ev.target;
            const index = node.dataset.key;
            if (index) {
                if (node.classList.contains('gray')) {
                    return false;
                }

                const obj = offsetMap.seventh;
                const run = function(current, max, progress, type) {
                    setTimeout(() => {
                        if (type === 0) {
                            obj.box.scrollLeft = current - Math.min(max, progress);
                        } else {
                            obj.box.scrollLeft = current + Math.min(max, progress);
                        }

                        if (progress < max) {
                            run(current, max, progress + 20, type);
                        }
                    }, 10);
                };

                if (Number(index) === 0) {
                    run(obj.box.scrollLeft, obj.cardWidth, 20, 0);
                } else {
                    run(obj.box.scrollLeft, obj.cardWidth, 20, 1);
                }
            }
        });

        let seventhNode = offsetMap.seventh.card[0];
        nodeList.seventhItems.addEventListener('scroll', function(ev) {
            const obj = offsetMap.seventh;
            const left = ev.target.scrollLeft;

            if (isMobile) {
                obj.cardLeft.forEach((x, i) => {
                    if (x - left >= 0 && x + obj.cardWidth <= left + screenWidth + 20) {
                        if (seventhNode !== obj.card[i]) {
                            seventhNode.classList.remove('hover');
                            seventhNode = obj.card[i];
                            seventhNode.classList.add('hover');
                        }
                    }
                });

                return false;
            }

            if (left < 10 && sevenObj.prev) {
                sevenObj.prev = false;
                obj.prev.classList.add('gray');
            } else if (left >= 10 && !sevenObj.prev) {
                sevenObj.prev = true;
                obj.prev.classList.remove('gray');
            }

            if (left > obj.width - obj.realWidth - 10 && sevenObj.next) {
                sevenObj.next = false;
                obj.next.classList.add('gray');
            } else if (left <= obj.width - obj.realWidth - 10 && !sevenObj.next) {
                sevenObj.next = true;
                obj.next.classList.remove('gray');
            }
        });
    }


    // 第八屏处理
    let eightObj = {
        prev: false,
        next: true
    };

    function loadEighth() {
        const obj = offsetMap.eighth;
        if (obj) {
            // 显示前后按钮
            nodeList.eighthSlide.style.display = 'none';
            if (!isMobile && obj.width > obj.realWidth + 20) {
                nodeList.eighthSlide.style.display = 'flex';
            }
        }
    }

    loadEighth();

    if (offsetMap.eighth) {
        nodeList.eighthSlide.addEventListener('click', function(ev) {
            const node = ev.target;
            const index = node.dataset.key;
            if (index) {
                if (node.classList.contains('gray')) {
                    return false;
                }

                const obj = offsetMap.eighth;
                const run = function(current, max, progress, type) {
                    setTimeout(() => {
                        if (type === 0) {
                            obj.box.scrollLeft = current - Math.min(max, progress);
                        } else {
                            obj.box.scrollLeft = current + Math.min(max, progress);
                        }

                        if (progress < max) {
                            run(current, max, progress + 20, type);
                        }
                    }, 10);
                };

                if (Number(index) === 0) {
                    run(obj.box.scrollLeft, obj.cardWidth, 20, 0);
                } else {
                    run(obj.box.scrollLeft, obj.cardWidth, 20, 1);
                }
            }
        });

        let eighthNode = offsetMap.eighth.card[0];
        nodeList.eighthItems.addEventListener('scroll', function(ev) {
            const obj = offsetMap.eighth;
            const left = ev.target.scrollLeft;

            if (isMobile) {
                obj.cardLeft.forEach((x, i) => {
                    if (x - left >= 0 && x + obj.cardWidth <= left + screenWidth + 20) {
                        if (eighthNode !== obj.card[i]) {
                            eighthNode.classList.remove('hover');
                            eighthNode = obj.card[i];
                            eighthNode.classList.add('hover');
                        }
                    }
                });

                return false;
            }

            if (left < 10 && eightObj.prev) {
                eightObj.prev = false;
                obj.prev.classList.add('gray');
            } else if (left >= 10 && !eightObj.prev) {
                eightObj.prev = true;
                obj.prev.classList.remove('gray');
            }

            if (left > obj.width - obj.realWidth - 10 && eightObj.next) {
                eightObj.next = false;
                obj.next.classList.add('gray');
            } else if (left <= obj.width - obj.realWidth - 10 && !eightObj.next) {
                eightObj.next = true;
                obj.next.classList.remove('gray');
            }
        });
    }

    nodeList.scrollTop && nodeList.scrollTop.addEventListener('click', function() {
        window.scrollTo(0, 0);
    });
})();